import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details.rc.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details.rc.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { CreateApplicationDetailsRcConstants } from "./create-application-details-rc.constants";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { take, takeUntil } from "rxjs/operators";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
let CreateApplicationDetailsRcComponent = class CreateApplicationDetailsRcComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    appController;
    changeDetectorRefs;
    detailsForm;
    // Labels
    descriptionLabel = CreateApplicationDetailsRcConstants.DESCRIPTION_LABEL;
    typeLabel = CreateApplicationDetailsRcConstants.TYPE_LABEL;
    reasonForApplicationLabel = CreateApplicationDetailsRcConstants.REASON_FOR_APPLICATION;
    typeOfTransferLabel = CreateApplicationDetailsRcConstants.TYPE_OF_TRANSFER_LABEL;
    propertyTypeLabel = CreateApplicationDetailsRcConstants.PROPERTY_TYPE_LABEL;
    ratesAccountNumberLabel = CreateApplicationDetailsRcConstants.RATES_ACCOUNT_NUMBER_LABEL;
    electronicReferenceLabel = CreateApplicationDetailsRcConstants.ELECTRONIC_REFERENCE_LABEL;
    attorneyReferenceLabel = CreateApplicationDetailsRcConstants.ATTORNEY_REFERENCE_LABEL;
    councilReferenceLabel = CreateApplicationDetailsRcConstants.COUNCIL_REFERENCE_LABEL;
    validationMessages = CreateApplicationDetailsRcConstants.VALIDATION_MESSAGES;
    // Controls
    descriptionFormControlName = CreateApplicationDetailsRcConstants.DESCRIPTION_FORM_CONTROL_NAME;
    typeFormControlName = CreateApplicationDetailsRcConstants.TYPE_FORM_CONTROL_NAME;
    reasonForApplicationFormControlName = CreateApplicationDetailsRcConstants.REASON_FOR_APPLICATION_CONTROL_NAME;
    typeOfTransferFormControlName = CreateApplicationDetailsRcConstants.TYPE_OF_TRANSFER_CONTROL_NAME;
    propertyTypeFormControlName = CreateApplicationDetailsRcConstants.PROPERTY_TYPE_CONTROL_NAME;
    ratesAccountNumberFormControlName = CreateApplicationDetailsRcConstants.RATES_ACCOUNT_NUMBER_CONTROL_NAME;
    electronicReferenceFormControlName = CreateApplicationDetailsRcConstants.ELECTRONIC_REFERENCE_CONTROL_NAME;
    attorneyReferenceFormControlName = CreateApplicationDetailsRcConstants.ATTORNEY_REFERENCE_CONTROL_NAME;
    councilReferenceFormControlName = CreateApplicationDetailsRcConstants.COUNCIL_REFERENCE_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    applicationTypes = [];
    typeOfTransferLookupOptions = [];
    constructor(createApplicationService, aflaModuleStrategyService, appController, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        if (this.appController.moduleSimulateMode) {
            let defaults = SimulationUtils.simulate_Create_Application();
            this.applicationTypes = defaults.applicationType;
            this.typeOfTransferLookupOptions = defaults.transferType;
        }
        else {
            if (this.aflaModuleStrategyService.lookups.has("applicationTypes") && this.aflaModuleStrategyService.lookups.has("transferType")) {
                this.applicationTypes = this.aflaModuleStrategyService.lookups.get("applicationTypes");
                this.typeOfTransferLookupOptions = this.aflaModuleStrategyService.lookups.get("transferType");
            }
            else {
                this.getLookups();
            }
            this.getMetadata();
        }
        this.initForm();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    loadMetadata(stepMeta) {
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.createApplicationService.moduleID}`,
        };
        this.createApplicationService.getLookupsObservable(params).pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationDetailsRcConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        const typeOfTransfer = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name?.toLowerCase() === "applicationtype") {
                    applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name?.toLowerCase() === "transfertype") {
                    typeOfTransfer.push(JSON.parse(item.content));
                }
            });
        }
        applicationTypes.sort((a, b) => a.value.localeCompare(b.value));
        typeOfTransfer.sort((a, b) => a.value.localeCompare(b.value));
        this.aflaModuleStrategyService.lookups.set("applicationTypes", applicationTypes);
        this.aflaModuleStrategyService.lookups.set("transferType", typeOfTransfer);
        this.applicationTypes = applicationTypes;
        this.typeOfTransferLookupOptions = typeOfTransfer;
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationDetailsRcComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-details.rc",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsRcComponent);
export { CreateApplicationDetailsRcComponent };
